import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminSubscriptionCancelations = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/subscription_cancelations/index.vue')
    createVueApp(IndexPage, { props })
  }
}
